module.exports = __webpack_public_path__ + "media/img/courses-logo2-9dc203eca8162588e25e3fa5bebc045d.svg";